import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import HttpApi from 'i18next-http-backend';

i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        lng: "en", // Forzar idioma inglés
        fallbackLng: "en",
        supportedLngs: ['en'],
        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i"],
        },
        backend: {
            loadPath: 'locales/{{lng}}.json'
        },
    });

export default i18n;